import React, { Component } from 'react';
import PropTypes from 'prop-types';
import PracticeNews from './PracticeNews';
import ForumNews from './ForumNews';
import EducationNews from './EducationNews';
import NewsSlider from './NewsSlider';
import SocialBlock from '../../components/SocialBlock/SocialBlock';
import WelcomeModal from '../../components/Modals/WelcomeModal';
import { withCookies, Cookies } from 'react-cookie';

class Main extends Component {
  constructor(props) {
    super(props);

    this.dontShowWelcomeModalCookieName = 'dontShowWelcomeModal';
    const { cookies } = props;
    this.state = {
      showWelcomeBlock: !cookies.get(this.dontShowWelcomeModalCookieName),
    };
  }

  static propTypes = {
    //cookies: instanceOf(Cookies).isRequired,
  };

  unmountWelcomeModal = (setDownShowCookie) =>  {
    if (setDownShowCookie) {
      this.props.cookies.set(this.dontShowWelcomeModalCookieName, true);
    }
    this.setState({ showWelcomeBlock: false });
  }

  render() {
    return (
      <div className="b-center">
        <PracticeNews />
        <ForumNews />
        <EducationNews />
        <NewsSlider />

        <SocialBlock />

        {this.state.showWelcomeBlock ? (
          <WelcomeModal unmount={(setDownShowCookie) => { this.unmountWelcomeModal(setDownShowCookie) }}/>
        ) : (
          ''
        )}
      </div>
    );
  }
}

export default withCookies(Main);